import UserOnboarding from './UserOnboarding';

export default UserOnboarding;
